import React from 'react';
import styles from './CTABackground.module.css';

/**
 * @component CTABackground
 * @description CTA 섹션 배경 이미지 컴포넌트
 *
 * 이미지 교체 전략:
 * - src prop으로 이미지 경로를 주입받아 렌더링
 * - 실제 이미지 교체 시 CTA_DATA.background.src 경로만 수정
 * - 섹션 구조는 변경하지 않아도 됨
 *
 * hover 전환:
 * - 기본: grayscale(100%) — 흑백 처리
 * - 부모(.ctaSection)에 hover 시: grayscale(0%) — 원본 컬러
 * - 모바일: @media (hover: none) → 기본 컬러 유지
 */
function CTABackground({ src, alt }) {
  return (
    <div className={styles.backgroundWrapper}>
      {src ? (
        <img src={src} alt={alt} className={styles.backgroundImage} />
      ) : (
        <div className={styles.backgroundPlaceholder} aria-hidden="true" />
      )}
    </div>
  );
}

export default CTABackground;
